// extracted by mini-css-extract-plugin
module.exports = {"section":"B_section__A_n2E"};